/* SOL measurement: permitted analytics only; contact actions are not bookings. */
(() => {
  if (window.__solMeasurementLoaded) return;
  window.__solMeasurementLoaded = true;
  const id = 'G-0WV4V0CVXB';
  const qs = new URLSearchParams(location.search);
  const debug = qs.get('sol_analytics_debug') === '1';
  if ((qs.has('preview_theme_id') || window.Shopify?.theme?.role === 'unpublished') && !debug) return;
  let started = false;
  let lastAction = '';
  let lastTime = 0;
  const cleanUrl = raw => {
    if (!raw) return '';
    try {
      const u = new URL(raw, location.origin);
      const clean = new URL(u.origin + u.pathname);
      const sources = new Set(['google','google_maps','facebook','instagram','line','whatsapp','chungta','bing','youtube']);
      const media = new Set(['organic','cpc','referral','social','email','paid_social','local']);
      if (sources.has(u.searchParams.get('utm_source'))) clean.searchParams.set('utm_source', u.searchParams.get('utm_source'));
      if (media.has(u.searchParams.get('utm_medium'))) clean.searchParams.set('utm_medium', u.searchParams.get('utm_medium'));
      const campaign = u.searchParams.get('utm_campaign') || '';
      if (/^[A-Za-z][A-Za-z0-9_-]{0,79}$/.test(campaign)) clean.searchParams.set('utm_campaign', campaign);
      if (window.Shopify?.customerPrivacy?.marketingAllowed?.() === true) {
        for (const key of ['gclid','gbraid','wbraid']) {
          const value = u.searchParams.get(key) || '';
          if (/^[A-Za-z0-9_-]{1,250}$/.test(value)) clean.searchParams.set(key, value);
        }
      }
      return clean.href;
    }
    catch { return ''; }
  };
  const allowed = () => window.Shopify?.customerPrivacy?.analyticsProcessingAllowed() === true;
  const service = () => /hair-wash/.test(location.pathname) ? 'hair_wash' : /hot-stone/.test(location.pathname) ? 'hot_stone' : /chinese-wellness/.test(location.pathname) ? 'chinese_wellness' : /home-massage|massage-at-home/.test(location.pathname) ? 'at_home' : /sol-chungta/.test(location.pathname) ? 'collaboration' : 'general';
  const send = (event, fields = {}) => {
    if (!started || !allowed()) return;
    window.gtag('event', event, {
      send_to: id,
      page_location: cleanUrl(location.href),
      page_referrer: cleanUrl(document.referrer),
      service_group: service(),
      site_language: document.documentElement.lang,
      ...(debug ? {debug_mode: true} : {}),
      ...fields
    });
    if (debug) document.documentElement.dataset.solAnalyticsLastEvent = event;
  };
  const start = () => {
    const permitted = allowed();
    window['ga-disable-' + id] = !permitted;
    if (!permitted) {
      document.documentElement.dataset.solAnalytics = 'consent_required';
      return;
    }
    if (started) return;
    started = true;
    const needsBootstrap = typeof window.gtag !== 'function';
    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };
    // Reuse the existing Google tag loader rather than loading another library.
    if (!document.querySelector('script[src*="googletagmanager.com/gtag/js"]')) {
      const tag = document.createElement('script');
      tag.async = true;
      tag.src = 'https://www.googletagmanager.com/gtag/js?id=' + id;
      document.head.appendChild(tag);
    }
    if (needsBootstrap) window.gtag('js', new Date());
    window.gtag('config', id, {
      send_page_view: false,
      page_location: cleanUrl(location.href),
      page_referrer: cleanUrl(document.referrer),
      allow_google_signals: false,
      allow_ad_personalization_signals: false,
      ...(debug ? {debug_mode: true} : {})
    });
    send('page_view');
    document.documentElement.dataset.solAnalytics = 'ready';
  };
  const init = () => {
    if (window.Shopify?.customerPrivacy?.analyticsProcessingAllowed) return start();
    if (window.Shopify?.loadFeatures) {
      window.Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.2'}], error => {
        if (!error) start();
      });
    }
  };
  document.addEventListener('visitorConsentCollected', start);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once: true});
  else init();
  document.addEventListener('click', event => {
    const el = event.target instanceof Element ? event.target.closest('a,button') : null;
    if (!el || event.defaultPrevented) return;
    const href = el.getAttribute('href') || '';
    let channel = '';
    let action = 'contact_click';
    if (/^https:\/\/(?:wa\.me|api\.whatsapp\.com)\//i.test(href)) channel = 'whatsapp';
    else if (/^https:\/\/(?:lin\.ee|line\.me)\//i.test(href)) channel = 'line';
    else if (/^tel:/i.test(href)) channel = 'phone';
    else if (el.matches('[data-sol-wc], [data-sol-wechat]') || el.getAttribute('aria-controls')?.toLowerCase().includes('wechat')) channel = 'wechat';
    else if (/google\.[^/]+\/maps|maps\.app\.goo\.gl|share\.google\//i.test(href)) {channel = 'google_maps'; action = 'directions_click';}
    if (!channel) return;
    const place = el.closest('#contact') ? 'contact_section' : el.closest('#header-group') ? 'header' : el.closest('footer,[id*="footer"]') ? 'footer' : 'main';
    const key = action + ':' + channel + ':' + place;
    const now = Date.now();
    if (key === lastAction && now - lastTime < 750) return;
    lastAction = key; lastTime = now;
    send(action, {contact_channel: channel, cta_location: place});
  }, {capture: true});
})();
